import { useWorkspace } from "@/hooks/workspace";
import { useState } from "react";
import { ExportDeductionItemUseCase } from "@/core/usecases/deduction/ExportDeductionItem.useCase";
import { ExportDeductionItemRepository } from "@/infrastructure/repositories/export/export.deductionItem.repository";

export function useDeductionItemExport() {
  const { settings: workspaceSettings } = useWorkspace();
  const [isDeductionItemExporting, setIsDeductionItemExporting] = useState(false);

  const handleDeductionItemExport = async (deductionId: number, invoiceNumber: string) => {
    
    const formats = {
      date: workspaceSettings?.displayDateFormat,
      number: workspaceSettings?.displayNumberFormat,
    };

    const params = {
      deduction_id: deductionId,
      invoice_number: invoiceNumber,
    };

    setIsDeductionItemExporting(true);
    return await new ExportDeductionItemUseCase(new ExportDeductionItemRepository()).execute({ formats, params });
  };

  return { handleDeductionItemExport, isDeductionItemExporting, setIsDeductionItemExporting };
}
